import apiClient from '../config/api';

const subscriptionService = {
  /**
   * Get all available subscription plans
   * @returns {Promise} Array of subscription plans
   */
  getPlans: async () => {
    const response = await apiClient.get('/subscription/plans');
    return response.data;
  },

  /**
   * Purchase a subscription plan
   * @param {number} tenantId - Tenant ID
   * @param {number} planId - Plan ID to purchase
   * @returns {Promise} Purchase response
   */
  purchaseSubscription: async (tenantId, planId) => {
    const response = await apiClient.post('/subscription/purchase', {
      tenantId,
      planId,
    });
    return response.data;
  },

  /**
   * Renew subscription
   * @param {number} tenantId - Tenant ID
   * @param {object} renewalData - Renewal data
   * @returns {Promise} Renewal response
   */
  renewSubscription: async (tenantId, renewalData) => {
    const response = await apiClient.post('/subscription/renew', {
      tenantId,
      ...renewalData,
    });
    return response.data;
  },

  /**
   * Change subscription plan
   * @param {number} tenantId - Tenant ID
   * @param {number} newPlanId - New plan ID
   * @returns {Promise} Change response
   */
  changeSubscription: async (tenantId, newPlanId) => {
    const response = await apiClient.post('/subscription/change', {
      tenantId,
      newPlanId,
    });
    return response.data;
  },

  /**
   * Check if tenant can change to a plan
   * @param {number} tenantId - Tenant ID
   * @param {number} newPlanId - New plan ID
   * @returns {Promise} Can change status
   */
  canChangeToPlan: async (tenantId, newPlanId) => {
    const response = await apiClient.get(`/subscription/can-change/${tenantId}/${newPlanId}`);
    return response.data;
  },

  /**
   * Get subscription usage summary
   * @param {number} tenantId - Tenant ID
   * @returns {Promise} Usage summary
   */
  getUsageSummary: async (tenantId) => {
    const response = await apiClient.get(`/subscription/usage/${tenantId}`);
    return response.data;
  },

  /**
   * Get current subscription
   * @param {number} tenantId - Tenant ID
   * @returns {Promise} Current subscription details
   */
  getCurrentSubscription: async (tenantId) => {
    const response = await apiClient.get(`/subscription/current/${tenantId}`);
    return response.data;
  },

  /**
   * Cancel subscription
   * @param {number} tenantId - Tenant ID
   * @returns {Promise} Cancellation response
   */
  cancelSubscription: async (tenantId) => {
    const response = await apiClient.post(`/subscription/cancel/${tenantId}`);
    return response.data;
  },

};

export default subscriptionService;

